import React, {useContext, useEffect, useState} from "react";
import {useTheme} from "../../../contexts/Theme/ThemeContext";
import {ToggleConfigurar} from "../../Toggle/ToggleConfigurar/ToggleConfigurar";
import {ConfiguracoesContext} from "../../../contexts/Configuracoes/ConfiguracoesContext";
import {AuthContext} from "../../../contexts/Auth/AuthContext";
import {EmpresaContext} from "../../../contexts/Empresa/EmpresaContext";
import {Input} from "../../Input";
import LockedIcon from "../../LockedIcon/LockedIcon";
import {Select} from "../../Select";
import {ContainerIntegracaoTiny} from "./styles";
import {produtosApi} from "../../../hooks/produtosApi";
import {PedidosApi} from "../../../hooks/pedidosApi";
import Dropdown from "../../Dropdowns/Dropdown";
import Swal from "sweetalert2";
import Modal from "../../Modal/Modal";
import {Button} from "../../Button";
import Pagamentos from "./Pagamentos/Pagamentos";

const EMPRESAS_TINY_V2_NOVAS_CONFIGS: number[] = [];

// Situações que não fazem sentido como gatilho de envio para o ERP
const SITUACOES_NAO_GATILHO = [3, 9]; // cancelado e excluído

const IntegracaoTiny: React.FC = ({}) => {
    const produtosApiHook = produtosApi();
    const pedidosApiHook = PedidosApi();

    const {theme} = useTheme();

    const {configuracoes, setConfiguracoes} = useContext(ConfiguracoesContext);
    const {permissoesPlanos} = useContext(AuthContext);
    const {empresa} = useContext(EmpresaContext);
    const permite2Niveis = permissoesPlanos["ADICIONAR_VARIACAO_SECUNDARIA"]?.permitido;
    const permiteSubcategorias = permissoesPlanos["SUBCATEGORIAS"]?.permitido;
    const [listasDePreco, setListasDePreco] = useState<any[]>([]);
    const [modalPagamentos, setModalPagamentos] = useState(false);
    const [situacoes, setSituacoes] = useState<{ id: number | string; descricao: string }[]>([]);

    const envioPedidos = configuracoes.dados_tiny_v2.envio_pedidos ?? "sempre";

    useEffect(() => {
        produtosApiHook
            .getTabelasDePreco()
            .then((response) => {
                setListasDePreco(response);
                if (!configuracoes.dados_tiny_v2.tabela_id) {
                    setConfiguracoes({
                        ...configuracoes,
                        dados_tiny_v2: {
                            ...configuracoes.dados_tiny_v2,
                            tabela_id: response[0].id,
                        },
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (envioPedidos !== "situacao" || situacoes.length > 0) return;
        pedidosApiHook
            .getSituacoes()
            .then((response) => {
                setSituacoes(
                    (response ?? []).filter(
                        (situacao) => !SITUACOES_NAO_GATILHO.includes(Number(situacao.id))
                    )
                );
            })
            .catch((error) => {
                console.log(error);
            });
    }, [envioPedidos]);

    const idEmpresa = empresa?.id;
    const isProducao = window.location.hostname === "www.painel.conectavenda.com.br";
    const novasConfigsLiberadas =
        !isProducao ||
        EMPRESAS_TINY_V2_NOVAS_CONFIGS.length === 0 ||
        (idEmpresa !== undefined && EMPRESAS_TINY_V2_NOVAS_CONFIGS.includes(idEmpresa));

    const hostname = window.location.hostname;
    const isLocal = hostname === "localhost" || hostname === "127.0.0.1" || hostname.startsWith("192.168.");
    const callBackUrl =
        "https://conectavenda.com.br/postback.php?origem=tiny&chave=";
    const webhookSituacaoUrl =
        "https://painel-api.conectavenda.com.br/tiny/webhook_situacao?chave=";

    const copiarUrl = (url: string) => {
        navigator.clipboard.writeText(url).then(
            () => {
                Swal.fire({
                    title: "URL copiada!",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });
            },
            () => {
                Swal.fire({
                    title: "Erro ao copiar URL!",
                    text: "Mas você pode copiar manualmente: " + url,
                    icon: "error",
                });
            }
        );
    };

    return (
        <>
            <ContainerIntegracaoTiny theme={theme}>
                <div className="textoTiny fonteTexto">
                    Conecte sua conta Olist ao Conecta Venda para automatizar a gestão de pedidos e produtos. <br/>
                    A integração permite que as informações fluam entre as plataformas, facilitando seu controle e
                    organização.
                </div>
                <div className="config">
                    <Input
                        onChange={(newValue) => {
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    chave: newValue,
                                },
                            });
                        }}
                        type="text"
                        value={configuracoes.dados_tiny_v2.chave}
                        placeholder="Chave de integração"
                        maxLength={64}
                        showMaxLength={false}
                        label="Chave de API"
                        required={true}
                        ignoreValidations={!configuracoes.dados_tiny_v2.ativo}
                    />
                </div>
                <Dropdown active={configuracoes.dados_tiny_v2.chave ? true : false}>
                    <div className="urlContainer fonteTexto">
                        <span>URL de callback:</span>
                        <div
                            className="url"
                            onClick={() => {
                                navigator.clipboard
                                    .writeText(callBackUrl + configuracoes.dados_tiny_v2.chave)
                                    .then(
                                        (res) => {
                                            Swal.fire({
                                                title: "URL copiada!",
                                                icon: "success",
                                                timer: 1500,
                                                showConfirmButton: false,
                                            });
                                        },
                                        (err) => {
                                            Swal.fire({
                                                title: "Erro ao copiar URL!",
                                                text:
                                                    "Mas você pode copiar manualmente: " +
                                                    callBackUrl +
                                                    configuracoes.dados_tiny_v2.chave,
                                                icon: "error",
                                            });
                                        }
                                    );
                            }}
                        >
                            <span>{callBackUrl}</span>
                            <span>{configuracoes.dados_tiny_v2.chave}</span>
                        </div>
                    </div>
                    {novasConfigsLiberadas && (
                    <div className="urlContainer fonteTexto">
                        <span>URL de webhook (situação do pedido):</span>
                        <div
                            className="url"
                            onClick={() => copiarUrl(webhookSituacaoUrl + configuracoes.dados_tiny_v2.chave)}
                        >
                            <span>{webhookSituacaoUrl}</span>
                            <span>{configuracoes.dados_tiny_v2.chave}</span>
                        </div>
                    </div>
                    )}
                </Dropdown>
                {isLocal && configuracoes.dados_tiny_v2.chave && (
                    <div className="obs fonteRotulos" style={{marginTop: 8, marginBottom: 8}}>
                        <strong>Ambiente local:</strong> O Tiny não consegue enviar postback para localhost.
                        Para testar, abra no navegador:<br/>
                        <a
                            href={`http://${hostname}/conecta-scheduler/libs/erp/teste_tiny_postback.php?chave=${configuracoes.dados_tiny_v2.chave}&produto_id=ID_DO_PRODUTO`}
                            target="_blank"
                            rel="noreferrer"
                            style={{textDecoration: "underline"}}
                        >
                            {`http://${hostname}/conecta-scheduler/libs/erp/teste_tiny_postback.php?chave=${configuracoes.dados_tiny_v2.chave}&produto_id=`}<strong>ID_DO_PRODUTO</strong>
                        </a>
                        <br/>Substitua <strong>ID_DO_PRODUTO</strong> pelo ID do produto no Tiny.
                    </div>
                )}
                <label className="config">
                    <ToggleConfigurar
                        onChange={(newValue) => {
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    upload_fotos_conecta: newValue,
                                },
                            });
                        }}
                        value={configuracoes.dados_tiny_v2.upload_fotos_conecta}
                    />
                    <div className="title fonteTexto">Upload de fotos pelo Conecta Venda</div>
                </label>

                <label className="config">
                    <ToggleConfigurar
                        onChange={(newValue) => {
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    controle_estoque: newValue,
                                },
                            });
                        }}
                        value={configuracoes.dados_tiny_v2.controle_estoque}
                    />
                    <div className="title fonteTexto">Controle de estoque</div>
                </label>

                <label className="config">
                    <ToggleConfigurar
                        onChange={(newValue) => {
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    nome_descricao: newValue,
                                },
                            });
                        }}
                        value={configuracoes.dados_tiny_v2.nome_descricao}
                    />
                    <div className="title fonteTexto">Utilizar nome do produto como descrição</div>
                </label>

                {!configuracoes.dados_tiny_v2.nome_descricao && (
                    <label className="config">
                        <ToggleConfigurar
                            onChange={(newValue) => {
                                setConfiguracoes({
                                    ...configuracoes,
                                    dados_tiny_v2: {
                                        ...configuracoes.dados_tiny_v2,
                                        usar_descricao_complementar: newValue,
                                    },
                                });
                            }}
                            value={configuracoes.dados_tiny_v2.usar_descricao_complementar}
                        />
                        <div className="title fonteTexto">Importar descrição complementar</div>
                    </label>
                )}

                <label className="config">
                    <ToggleConfigurar
                        onChange={(newValue) => {
                            if (!permite2Niveis) return;
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    suporta_2_variacoes: newValue,
                                },
                            });
                        }}
                        value={permite2Niveis ? (configuracoes.dados_tiny_v2.suporta_2_variacoes ?? false) : false}
                    />
                    <div className={`title fonteTexto${!permite2Niveis ? ' bloqueado' : ''}`}>
                        Separar variações em 2 níveis <strong>(Ex: Tamanho + Cor)</strong>
                    </div>
                    {!permite2Niveis && (
                        <LockedIcon
                            mensagem="Recurso disponível a partir do plano Essencial."
                            width="2.4rem"
                            className="locked-icon"
                        />
                    )}
                </label>

                <div className="config">
                    <Select
                        placeholder="Selecione uma tabela de preço"
                        label="Tabela de preço"
                        sizeLabel="medium"
                        required={configuracoes.dados_tiny_v2.ativo}
                        onChange={(newValue) => {
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    tabela_id: newValue,
                                },
                            });
                        }}
                        value={configuracoes.dados_tiny_v2.tabela_id}
                        options={
                            listasDePreco
                                ? listasDePreco.map((lista) => {
                                    return {
                                        name: lista.descricao,
                                        value: lista.id,
                                    };
                                })
                                : [
                                    {
                                        name: "Padrão",
                                        value: 0,
                                    },
                                ]
                        }
                    />
                </div>

                <div className="configs">
                    <Input
                        onChange={(newValue) => {
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    identificador_integrador: newValue,
                                },
                            });
                        }}
                        type="text"
                        value={configuracoes.dados_tiny_v2.identificador_integrador}
                        placeholder="Identificador do integrador"
                        showMaxLength={false}
                        maxLength={64}
                        label="Identificador do integrador"
                        required
                        ignoreValidations={!configuracoes.dados_tiny_v2.ativo}
                    />
                    <Input
                        onChange={(newValue) => {
                            setConfiguracoes({
                                ...configuracoes,
                                dados_tiny_v2: {
                                    ...configuracoes.dados_tiny_v2,
                                    multiplicador: newValue,
                                },
                            });
                        }}
                        type="number"
                        required
                        step={"any"}
                        value={configuracoes.dados_tiny_v2.multiplicador}
                        placeholder="Multiplicador"
                        ignoreValidations={!configuracoes.dados_tiny_v2.ativo}
                        min={0.01}
                        max={100}
                        label="Multiplicador"
                    />
                </div>
                <div className="radioGroup fonteTexto">
                    <div className="radioTitle">
                        <strong>Importar categorias:</strong>
                    </div>
                    <label className="radioLabel">
                        <input
                            type="radio"
                            className="input-radio"
                            name="estrutura_categorias_tiny"
                            value="completa"
                            checked={configuracoes.dados_tiny_v2.estrutura_categorias !== "subcategorias"}
                            onChange={() => {
                                setConfiguracoes({
                                    ...configuracoes,
                                    dados_tiny_v2: {
                                        ...configuracoes.dados_tiny_v2,
                                        estrutura_categorias: "completa",
                                    },
                                });
                            }}
                        />
                        <span>Estrutura completa (ex: Joias - Anéis - Solitários)</span>
                    </label>
                    <label className={`radioLabel${!permiteSubcategorias ? ' bloqueado' : ''}`}>
                        <input
                            type="radio"
                            className="input-radio"
                            name="estrutura_categorias_tiny"
                            value="subcategorias"
                            disabled={!permiteSubcategorias}
                            checked={permiteSubcategorias && configuracoes.dados_tiny_v2.estrutura_categorias === "subcategorias"}
                            onChange={() => {
                                if (!permiteSubcategorias) return;
                                setConfiguracoes({
                                    ...configuracoes,
                                    dados_tiny_v2: {
                                        ...configuracoes.dados_tiny_v2,
                                        estrutura_categorias: "subcategorias",
                                    },
                                });
                            }}
                        />
                        <span>Subcategorias (ex: Joias {'>'} Anéis {'>'} Solitários → categoria: Anéis, subcategoria: Solitários)</span>
                        {!permiteSubcategorias && (
                            <LockedIcon
                                mensagem="Recurso disponível a partir do plano Essencial."
                                width="2rem"
                                className="locked-icon"
                            />
                        )}
                    </label>
                </div>
                {novasConfigsLiberadas && (
                    <>
                        <div className="grupoPedidos">
                            <div className="config">
                                <Select
                                    placeholder="Selecione quando enviar"
                                    label="Envio de pedidos para o Olist"
                                    sizeLabel="medium"
                                    onChange={(newValue) => {
                                        setConfiguracoes({
                                            ...configuracoes,
                                            dados_tiny_v2: {
                                                ...configuracoes.dados_tiny_v2,
                                                envio_pedidos: newValue as "sempre" | "situacao" | "nunca",
                                            },
                                        });
                                    }}
                                    value={envioPedidos}
                                    options={[
                                        {name: "Assim que o pedido for criado", value: "sempre"},
                                        {name: "A partir de uma situação específica", value: "situacao"},
                                        {name: "Não enviar pedidos para o Olist", value: "nunca"},
                                    ]}
                                />
                            </div>

                            {envioPedidos === "situacao" && (
                                <div className="config">
                                    <Select
                                        placeholder="Selecione uma situação"
                                        label="Enviar quando o pedido chegar na situação"
                                        sizeLabel="medium"
                                        required={configuracoes.dados_tiny_v2.ativo}
                                        onChange={(newValue) => {
                                            setConfiguracoes({
                                                ...configuracoes,
                                                dados_tiny_v2: {
                                                    ...configuracoes.dados_tiny_v2,
                                                    situacao_envio: newValue,
                                                },
                                            });
                                        }}
                                        value={configuracoes.dados_tiny_v2.situacao_envio ?? ""}
                                        options={situacoes.map((situacao) => {
                                            return {
                                                name: situacao.descricao,
                                                value: situacao.id,
                                            };
                                        })}
                                    />
                                </div>
                            )}

                            {envioPedidos !== "nunca" && (
                                <label className="config">
                                    <ToggleConfigurar
                                        onChange={(newValue) => {
                                            setConfiguracoes({
                                                ...configuracoes,
                                                dados_tiny_v2: {
                                                    ...configuracoes.dados_tiny_v2,
                                                    lancar_estoque: newValue,
                                                },
                                            });
                                        }}
                                        value={configuracoes.dados_tiny_v2.lancar_estoque ?? true}
                                    />
                                    <div className="title fonteTexto">Dar baixa no estoque do Olist ao enviar o pedido</div>
                                </label>
                            )}
                        </div>
                        <Modal
                            width={"100rem"}
                            maxWidth="98vw"
                            isOpen={modalPagamentos}
                            setModal={setModalPagamentos}
                            backdrop={"static"}
                        >
                            <Pagamentos onClose={() => setModalPagamentos(false)}/>
                        </Modal>
                        <div className="config">
                            <Button title="Mapear pagamentos" onClick={() => setModalPagamentos(true)}/>
                        </div>
                    </>
                )}
                <div className="obs fonteRotulos">
                    <strong>Observações:</strong> <br/>
                    - Todo o processo de importação dos produtos, preços e estoques devem
                    ser realizados pela plataforma da Olist. <br/>- Ao excluir um produto
                    no Olist, será necessário excluir manualmente no Conecta.
                </div>
            </ContainerIntegracaoTiny>
        </>
    );
};
export default IntegracaoTiny;
